import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import cx from "classnames";
// import { CSSTransition } from "react-transition-group";

import QuestionForm from "modules/general-info/question-form";
// import { ANIMATION_DURATION } from "modules/general-info/question-form-constants";
import { getAnimationState } from "modules/diagnostic/diagnostic-selectors";

// const keys = {};

class QuestionFormAnimated extends Component {
  static propTypes = {
    form: PropTypes.string,
    action: PropTypes.string,
    state: PropTypes.string,
    direction: PropTypes.string
  };

  render() {
    const { action, state, direction, ...rest } = this.props;
    const className = cx({
      [`${direction}-${action}`]: true,
      [`${direction}-${action}-${state}`]: state !== "none"
    });
    return <QuestionForm key={rest.form} className={className} {...rest} />;
  }
}

export default connect(getAnimationState)(QuestionFormAnimated);



// WEBPACK FOOTER //
// ./src/modules/general-info/question-form-animated.js